const getters = () => {
  return {
    SET_STATE: (state) => {
      return state + 2;
    }
  }
};

//触发getters
// this.$store.getters.SET_STATE

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js